/// <reference path="../../node_modules/@types/grecaptcha/index.d.ts" />
/// <reference path="../../node_modules/@types/jquery.form/index.d.ts" />
/// <reference path="../../node_modules/@types/jquery-validation-unobtrusive/index.d.ts" />

module DBS.PartialView
{
    let rootElement: HTMLElement;

    function recaptchaCallback()
    {
        $(rootElement).ajaxSubmit({
            success: (response) =>
            {
                $(rootElement).html(response);
            },
            error: (xhr) =>
            {
                $(rootElement).html(xhr.responseText);
            }
        });
    }

    export function Initialise(rootElemId: string, recaptchaElemId: string)
    {
        const rootElem = document.getElementById(rootElemId);
        if (rootElem == null)
        {
            return;
        }
        rootElement = rootElem;

        $(rootElem).validate().destroy();
        $.validator.unobtrusive.parse($(rootElem));

        const recaptchaElem = document.getElementById(recaptchaElemId);
        if (recaptchaElem == null)
        {
            return;
        }

        const recaptchaKey = recaptchaElem.dataset["sitekey"];
        if (recaptchaKey == null)
        {
            return;
        }

        const recaptchaId = grecaptcha.render(recaptchaElemId,
            {
                sitekey: recaptchaKey,
                callback: recaptchaCallback
            },
            true);

        $(rootElem).validate().settings.submitHandler = () =>
        {
            grecaptcha.execute(recaptchaId);
        };
    }
}